exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".score-header-popper{width:256px;line-height:1.625;font-size:11px;font-weight:400;text-align:left}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/pages/InternAuditPerformanceTable.vue"],"names":[],"mappings":"AACA,qBAAqB,YAAY,kBAAkB,eAAe,gBAAmB,eAAe,CACnG","file":"InternAuditPerformanceTable.vue","sourcesContent":["\n.score-header-popper{width:256px;line-height:1.625;font-size:11px;font-weight:normal;text-align:left\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c2b8efa","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/audit-intern/pages/InternAuditPerformanceTable.vue
// module id = 3259
// module chunks = 275